export default {
  badge: 'Lencana',
  open: 'Buka',
  close: 'Tutup',
  dismiss: 'Tutup',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Batal',
  },
  dataIterator: {
    noResultsText: 'Tidak ditemukan catatan yang cocok',
    loadingText: 'Memuat data...',
  },
  dataTable: {
    itemsPerPageText: 'Baris per halaman:',
    ariaLabel: {
      sortDescending: 'Diurutkan kebawah.',
      sortAscending: 'Diurutkan keatas.',
      sortNone: 'Tidak diurutkan.',
      activateNone: 'Aktifkan untuk menghapus penyortiran.',
      activateDescending: 'Aktifkan untuk mengurutkan kebawah.',
      activateAscending: 'Aktifkan untuk mengurutkan keatas.',
    },
    sortBy: 'Urutkan berdasar',
  },
  dataFooter: {
    itemsPerPageText: 'Item per halaman:',
    itemsPerPageAll: 'Semua',
    nextPage: 'Halaman selanjutnya',
    prevPage: 'Halaman sebelumnya',
    firstPage: 'Halaman pertama',
    lastPage: 'Halaman terakhir',
    pageText: '{0}-{1} dari {2}',
  },
  dateRangeInput: {
    divider: 'hingga',
  },
  datePicker: {
    itemsSelected: '{0} dipilih',
    range: {
      title: 'Pilih tanggal',
      header: 'Masukkan tanggal',
    },
    title: 'Pilih tanggal',
    header: 'Masukkan tanggal',
    input: {
      placeholder: 'Masukkan tanggal',
    },
    ariaLabel: {
      previousMonth: 'Bulan sebelumnya',
      nextMonth: 'Bulan berikutnya',
      selectYear: 'Pilih tahun',
      previousYear: 'Tahun sebelumnya',
      nextYear: 'Tahun berikutnya',
      selectMonth: 'Pilih bulan',
      selectDate: '{0}',
      currentDate: 'Hari ini, {0}',
    },
  },
  noDataText: 'Tidak ada data tersedia',
  carousel: {
    prev: 'Visual sebelumnya',
    next: 'Visual selanjutnya',
    ariaLabel: {
      delimiter: 'Slide {0} dari {1}',
    },
  },
  calendar: {
    moreEvents: '{0} lagi',
    today: 'Hari ini',
  },
  input: {
    clear: 'Bersihkan {0}',
    prependAction: '{0} aksi diawal',
    appendAction: '{0} aksi diakhir',
    otp: 'Masukkan karakter OTP {0}',
  },
  fileInput: {
    counter: '{0} berkas',
    counterSize: '{0} berkas (dari total {1})',
  },
  fileUpload: {
    title: 'Seret dan lepas berkas di sini',
    divider: 'atau',
    browse: 'Telusuri Berkas',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Pilih Waktu',
    hour: 'Jam',
    minute: 'Menit',
    second: 'Detik',
  },
  pagination: {
    ariaLabel: {
      root: 'Navigasi Halaman',
      next: 'Halaman selanjutnya',
      previous: 'Halaman sebelumnya',
      page: 'Buka halaman {0}',
      currentPage: 'Halaman saat ini, Halaman {0}',
      first: 'Halaman pertama',
      last: 'Halaman terakhir',
    },
  },
  stepper: {
    next: 'Selanjutnya',
    prev: 'Sebelumnya',
  },
  rating: {
    ariaLabel: {
      item: 'Penilaian {0} dari {1}',
    },
  },
  loading: 'Memuat...',
  infiniteScroll: {
    loadMore: 'Muat lebih banyak',
    empty: 'Tidak ada lagi',
  },
  rules: {
    required: 'Kolom ini wajib diisi',
    email: 'Masukkan alamat email yang valid',
    number: 'Kolom ini hanya boleh berisi angka',
    integer: 'Kolom ini hanya boleh berisi bilangan bulat',
    capital: 'Kolom ini hanya boleh berisi huruf kapital',
    maxLength: 'Anda harus memasukkan maksimum {0} karakter',
    minLength: 'Anda harus memasukkan minimum {0} karakter',
    strictLength: 'Panjang kolom yang dimasukkan tidak valid',
    exclude: 'Karakter {0} tidak diperbolehkan',
    notEmpty: 'Pilih setidaknya satu nilai',
    pattern: 'Format tidak valid',
  },
  hotkey: {
    then: 'kemudian',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Enter',
    escape: 'Escape',
    upArrow: 'Panah Atas',
    downArrow: 'Panah Bawah',
    leftArrow: 'Panah Kiri',
    rightArrow: 'Panah Kanan',
    backspace: 'Hapus',
    space: 'Spasi',
    plus: 'plus',
    shortcut: 'Pintasan keyboard: {0}',
    or: 'atau',
  },
  video: {
    play: 'Putar',
    pause: 'Jeda',
    seek: 'Cari',
    volume: 'Volume',
    showVolume: 'Tampilkan kontrol volume',
    mute: 'Bisukan',
    unmute: 'Bunyikan',
    enterFullscreen: 'Layar penuh',
    exitFullscreen: 'Keluar dari layar penuh',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Pilih warna dari layar',
      hueSlider: 'Rona',
      alphaSlider: 'Alfa',
      redInput: 'Merah',
      greenInput: 'Hijau',
      blueInput: 'Biru',
      alphaInput: 'Alfa',
      hueInput: 'Rona',
      saturationInput: 'Saturasi',
      lightnessInput: 'Kecerahan',
      hexInput: 'Nilai HEX',
      hexaInput: 'HEX dengan nilai alfa',
      changeFormat: 'Ubah format warna',
    },
  },
}
